import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import TagChip from "../TagChip";

const ContactTagsModal = ({ contact, onClose, onSaved }) => {
  const [allTags, setAllTags] = useState([]);
  const [selected, setSelected] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!contact) return;
    setSelected(contact.tags || []);
    (async () => {
      try {
        const { data } = await api.get("/tags");
        setAllTags(data.tags);
      } catch (err) {
        toastError(err);
      }
    })();
  }, [contact]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/contacts/${contact.id}/tags`, {
        tagIds: selected.map((t) => t.id),
      });
      onSaved(contact.id, data.tags);
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!contact} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {i18n.t("tags.contactTitle")}
        {contact ? ` — ${contact.name}` : ""}
      </DialogTitle>
      <DialogContent dividers>
        {allTags.length === 0 ? (
          <Typography variant="body2" color="textSecondary">
            {i18n.t("tags.noneCreated")}
          </Typography>
        ) : (
          <Autocomplete
            multiple
            options={allTags}
            value={selected}
            getOptionLabel={(t) => t.name}
            getOptionSelected={(a, b) => a.id === b.id}
            onChange={(_e, value) => setSelected(value)}
            renderTags={(value, getTagProps) =>
              value.map((tag, index) => (
                <TagChip tag={tag} {...getTagProps({ index })} key={tag.id} />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                margin="dense"
                label={i18n.t("tags.select")}
              />
            )}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          {i18n.t("tags.buttons.close")}
        </Button>
        <Button color="primary" variant="contained" onClick={handleSave} disabled={saving || allTags.length === 0}>
          {i18n.t("tags.buttons.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactTagsModal;
